<template>
  <teleport to="#flooring-finder-app">
    <div
      class="
        tw-fixed
        tw-top-0
        tw-left-0
        tw-w-full
        tw-h-full
        tw-flex
        tw-justify-center
        tw-items-center
        tw-bg-gray-600
        tw-bg-opacity-75
        tw-z-20
      "
    >
      <div class="tw-bg-white tw-w-full tw-max-w-lg md:tw-max-w-4xl">
        <div class="tw-border-b-1 tw-py-4 tw-px-6 tw-flex tw-justify-between">
          <div
            class="tw-text-noraLightBlue-100 tw-font-bold"
            v-html="title"
          ></div>
          <button @click="$emit('close')">
            <XIcon class="tw-h-4 tw-w-4" />
          </button>
        </div>

        <div>
          <slot />
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { XIcon } from "@heroicons/vue/solid";

export default {
  emits: ["close"],
  props: {
    title: String,
  },
  mounted() {
    disableBodyScroll(this.$el);
  },
  beforeUnmount() {
    enableBodyScroll(this.$el);
  },
  components: {
    XIcon,
  },
};
</script>

<style lang="scss" scoped>
.modal {
  transform: translateY(-50%);
}
</style>
